const ko = {
    updateSuccess: '업데이트 성공',
    updateFailed: '업데이트 실패',
    delOrgSuccess: '조직이 성공적으로 삭제되었으며 다음 조직이 전환됩니다. ',
    delOrgFailed: '조직 삭제 실패',
    addSuccess: '성공적으로 추가되었습니다',
    addFailed: '추가 실패',
    authSetSuccess: '권한이 성공적으로 설정되었습니다. 보려면 페이지를 새로 고침하세요. ',
    authSetFailed: '권한 설정 실패',
    disblMemSuccess: '멤버 비활성화 성공',
    disblMemFailed: '멤버 비활성화 실패',
    viewOrgRepo: '조직 저장소 뷰',
    fullPermissions: '전체 권한',
    editOrgDetails: '조직 세부 정보 수정',
    manageSubOrgs: '하위 조직 관리',
    manageOrgMems: '조직 구성원 관리',
    manageOrgDetailsMems: '조직 세부 정보 및 회원 관리',
    orgRepoInbound: '조직 저장소(인바운드)',
    orgRepoOut: '조직 저장소(출력)',
    manageSubOrgRepos: '하위 조직 창고 관리(창고 내외부)',
    manageSubOrgAndMeb:'하위 조직 및 구성원 관리',
    mobileNumber: '휴대전화번호',
    purview: '권한',
    avatar: '아바타',
    phNumber: '휴대전화번호',
    setPermissions: '권한 설정',
    disable: '비활성화',
    enable: '활성화',
    thisMember:'이 회원?',
    delOrgTip1: '이 조직을 삭제하시겠습니까? ',
    delOrgTip2: '이 조직을 삭제한 후에는 조직 정보를 복구할 수 없으며 조직에 속한 사용자도 삭제됩니다. 삭제를 확인하시겠습니까? ',
    createNewMem: '새로운 멤버 생성',
    selPerson: '사람을 선택해주세요',
    orgInfo: '조직 세부 정보',
    addOrg: '조직 추가',
    addSubOrgBut: '하위 조직 추가',
    members: '회원',
    noMem: '아직 회원이 없습니다',
    name: '이름',
    orgNameRequired: '조직 이름은 비워둘 수 없습니다!',
    desc: '설명',
    cancel: '취소',
    memList: '멤버 목록',
    addOrgMem: '조직 구성원 추가',
    selMem : '멤버를 선택해주세요',
    setMemPurview: '멤버({{userName}}) 권한 설정',
    memDetails: '회원 세부 정보',
    prompt: '프롬프트',
    conAction: '정말 원하시나요?',
    enterName: '이름을 입력하세요',
    enterDesc: '설명을 입력하세요',
    managOrgUser: '시스템 관리자/시스템 관리자, 관리자 조직|사용자',
    editOrgBasicInfo: '조직 기본 정보 수정',
    manageOrgUsers: '조직 사용자 관리',
    manageOrgProfile: '조직 프로필 관리',
    inboundManag: '인바운드 관리',
    outboundManag: '아웃바운드 관리',
    manageSubInv: '하위 레벨 재고 ​​관리',
    unPurview:'알 수 없는 권한',
    plEnterOrgName: "조직 이름을 입력하세요",
    addOrgStru: "조직 추가",
    noMove: "동일한 레벨에서 움직임이 없습니다",
    addSubOrg: "({{name}}의 하위 조직 추가",
    noData: "데이터 없음",
    delOrgTip3: "이 조직에는 하위 조직이 있습니다. 삭제하기 전에 하위 조직을 삭제하세요.",
    orgMoveSuc: "조직 이동 성공",
    orgMoveFail: "조직 이동 실패",
    selectAll: "모두 선택",
    userNoOrg: "사용자는 조직의 구성원이 아니며 5초 후에 로그아웃됩니다.",
    cancelTip: "현재 선택된 사람입니다. 취소하시겠습니까?",
    delOrg: "조직 삭제",
    plEnterUserName: "검색하시려면 Name1, Name2, 휴대폰 번호를 입력하세요",
    noOrgData: "조직 데이터를 찾을 수 없음/조직을 삭제할 수 없음",
    orgFetchFail: '조직 정보를 얻지 못했습니다',
    orgListEmpty: "현재 조직이 없습니다. 먼저 조직을 추가하세요.",
    selectOrg: "먼저 조직을 선택해주세요",
    orgDisabled: "조직이 비활성화되었거나 존재하지 않습니다",
    modifyOrgInfo: "조직 정보 수정",
    addOrDisableOrgMember: "조직 구성원 추가/비활성화",
    orgMemberPermissions: "조직 구성원 권한 설정",
};

export default ko;